module.exports = __webpack_public_path__ + "img/cancel.4c44a709.png";